import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EErgoFormService } from '../../services/e-ergo-form.service';
import { EErgoRequestFormConfigService } from '../../services/e-ergo-request-form-config.service';
import { Base } from '../base/base';
import { User } from '../../models/user/user.model';

@Component({
  selector: 'e-ergo-dashboard',
  templateUrl: './e-ergo-dashboard.component.html',
  styleUrls: ['./e-ergo-dashboard.component.css'],
  providers: [EErgoRequestFormConfigService]
})
export class EErgoDashboardComponent extends Base implements OnInit, OnDestroy {
  private BusyA;
  private BusyB;
  private BusyC;
  private BusyD;
  forms: any;
  prevContinuationTokens: any = [];
  nextContinuationToken: string;
  emailAddress: string;

  constructor(private eErgoFormService: EErgoFormService, private router: Router) {
    super();
  }

  ngOnInit(): void {
    let user: User = this.getUserDetailsFromLocalStorage();
    this.emailAddress = user.emailAddress;

    this.BusyB = this
      .eErgoFormService
      .getOpenForms(this.emailAddress, this.nextContinuationToken)
      .subscribe(result => {
        this.forms = result.Item1;
        this.nextContinuationToken = result.Item2;
      });
  }

  public createNewForm() {
    this.router.navigate([`/e-ergo`]);
  }

  public gotoForm(templateName: string, formId: string) {
    this.router.navigate([`/${templateName}`, formId]);
  }

  public prevPage() {
    this.prevContinuationTokens.pop();

    this.BusyC = this
      .eErgoFormService
      .getOpenForms(this.emailAddress, this.prevContinuationTokens.at(-1))
      .subscribe(result => {
        this.forms = result.Item1;
        this.nextContinuationToken = result.Item2;
      });
  }

  public nextPage() {
    this.BusyC = this
      .eErgoFormService
      .getOpenForms(this.emailAddress, this.nextContinuationToken)
      .subscribe(result => {
        this.prevContinuationTokens.push(this.nextContinuationToken);
        this.forms = result.Item1;
        this.nextContinuationToken = result.Item2;
      });
  }

  ngOnDestroy(): void {
    if (this.BusyA) {
      this.BusyA.unsubscribe();
    }

    if (this.BusyB) {
      this.BusyB.unsubscribe();
    }

    if (this.BusyC) {
      this.BusyC.unsubscribe();
    }

    if (this.BusyD) {
      this.BusyD.unsubscribe();
    }
  }
}
